<template>
  <div>
    <div class="w-100 d-inline-block bg-introduction padding-bottom-five">
      <div class="container autoContent">
        <div class="row">
          <div class="col-xl-8 col-12 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block margin-xl-top-5">
              <h1 class="text-black fw-bold text-full-28 family-grand-stander margin-bottom-3 text-xs-size-20">
                Professional Mobile Cat Grooming Home Service In Dubai
              </h1>
              <p class="text-black text-size-14 family-inter-light text-full-13 margin-bottom-3">
                Are you in need of a budget-friendly mobile cat grooming service in Dubai? We are here to help you! At Dubai Pet Groomers, we believe that every kitten deserves individualized care and attention. Your cat’s well-being is our top priority. Through our personalized grooming approach, we aim to build a strong bond of trust with your cat.
              </p>
              <p class="text-black text-size-14 family-inter-light text-full-13 margin-bottom-3">
                Our passion for cats drives us to offer a wide array of solutions, from routine maintenance to specialized treatments tailored to suit a cat’s individual needs. We take great pride in providing a stress-free and gentle grooming experience, where your furry companions can relax and indulge in a moment of pure tranquillity. Our mobile cat grooming service, with dedication, is not only enhancing the beauty of your feline companions but also prioritizing their well-being and overall health.
              </p>
            </div>
          </div>
          <div class="col-xl-4 col-12 mt-3 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block 
              dog-about-image">
              <img class="w-100" v-lazy="require('@/assets/images/cat-about-image.png')" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-gallery gallery-section">
      <div class="container autoContent">
        <div class="row margin-top-4">
          <div class="col-12">
            <div class="w-100 d-inline-block text-center margin-top-2">
              <p class="mb-0 text-size-14 text-uppercase nav-color fw-bold inter-bold-family text-full-14">
                OUR Plans
              </p>
              <h2 class="half-black fw-bold text-full-24 family-grand-stander text-uppercase text-size-24 margin-bottom-2 text-xs-size-20">
                Mobile Cat Grooming Services We Offer
              </h2>
              <p class="margin-bottom-2 text-size-14 text-black inter-regular-family d-block w-85 m-auto w-xs-100 w-sm-100 w-md-100 w-ipad-100 text-full-13">
                Whether you want basic cat grooming or a complete pampering experience, Dubai Pet Groomers has best option for every pet and budget, and we are here to provide you high-quality mobile cat grooming services at a reasonable price. 
              </p>
            </div>
          </div>
        </div>
        <div class="row margin-top-4 margin-bottom-4">
      <div class="col-12">
        <div class="w-100 d-inline-block gallery-slider about-slider position-relative">
          <div class="carousel-container">
            <transition-group class="carousel" tag="div">
              <div v-for="(plan) in planDetailPrices" :key="plan.id" class="slide">
                <div class="card w-100 d-inline-block border-0 rounded-4">
                  <img class="slide-image w-100" :src="$getImageUrl(plan.image)" :alt="plan.image" />
                  <div class="card-body">
                    <h3 class="card-title text-size-14 inter-bold-family overflow-hidden margin-bottom-2 text-full-14">
                      {{ plan.name }}
                    </h3>
                    <p class="card-text text-black text-size-14 inter-regular-family overflow-hidden margin-bottom-2 text-full-13">
                      {{ plan.description }}
                    </p>
                    <a href="javascript:void(0)" class="nav-color rounded-5 text-uppercase text-size-13 d-inline-block medium-family border-blue me-xl-2 me-3 book-service-btn text-full-13"
                    @click="addToCart(plan)">
                      Book Service
                    </a>
                    <span class="text-size-16 nav-color fw-bold family-grand-stander d-inline-block mt-xl-0 mt-2 mt-lg-0 mt-md-0 text-full-16">
                      {{ plan.unit }} {{ plan.price }} 
                    </span>
                  </div>
                </div>
              </div>
            </transition-group>
            <div class="carousel-controls">
              <a href="javascript:void(0)" class="carousel-prev-btn position-absolute" @click="previous">
                <img class="position-absolute" src="@/assets/images/prev-left-icon.svg" alt="" />
              </a>
              <a href="javascript:void(0)" class="carousel-next-btn position-absolute" @click="next">
                <img class="position-absolute" src="@/assets/images/next-right-icon.svg" alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
      </div>
    </div>
   
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row mt-xl-5 mt-4">
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a
                class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
                @click="toggleCollapse"
                >
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              How regularly is it a good idea for me to brush my cat?
              </span>
              </a>
              <div :class="['collapse', { show: isOpen }]" id="collapseExample">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    Long-haired breeds require daily brushing, but short-haired variants may require weekly grooming sessions.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample2" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              Does my cat need daily baths?
              </span>
              </a>
              <div class="collapse" id="collapseExample2">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    No, daily bathing is not necessary. Daily bathing is only required for long-haired cats or those with skin problems. But it is recommended to give bath after 2 or 3 days, using mild and pet friendly products. You can consult us for any query relating to it.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample3" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              How can I make their grooming more efficient if my cat has sensitive skin?
              </span>
              </a>
              <div class="collapse" id="collapseExample3">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    If your pet has sensitive skin, hire a professional groomer or consulttoyour veterinarian for recommendations. Additionally, use a fine bristle brush and brush gently to avoid causing a disruption.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample4" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              What can I do if my cat's fur is matted?
              </span>
              </a>
              <div class="collapse" id="collapseExample4">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">                   
                    If you see mats, carefully work them out with a comb. To avoid skin damage, mats may need to be carefully removed out by a professional groomer to avoid skin injury.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample5" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              How should I respond if my cat dislikes grooming?
              </span>
              </a>
              <div class="collapse" id="collapseExample5">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light">
                    If your cat is not ready to groom, begin gradually and utilize better feedback systems, such as recommendations or toys, to make the activity more pleasant. A professional groomer knows the tips and tricks to groom your cat so you can contact us.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample6" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              Do I need to get my cat professionally groomed?
              </span>
              </a>
              <div class="collapse" id="collapseExample6">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    Consider hiring a professional grooming service if your cat has significant cat problem or skin disorders that require specialized care, or if you need conducting particular grooming responsibilities you can hire us.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block">
              <h2 class="text-black fw-bold filson-black-family text-full-28 w-65 w-xs-100 w-sm-100 w-md-100 w-ipad-100 margin-bottom-2 text-xs-size-20">
                Why Choose Us?
              </h2>
              <p class="mb-0 text-size-14 text-black family-inter-light text-full-13">
                We have a deep understanding of the unique needs of our feline friends. We are here with a mission to provide the most exceptional cat grooming services and resources to ensure your beloved cats look and feel their absolute best. Beyond grooming services at Dubai Pet Groomers, our experienced groomers provide valuable advice and tips for at-home grooming, ensuring you can continue to nurture your cat’s well-being.
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3 about-video-image">
              <img class="w-100" v-lazy="require('@/assets/images/cat-hair-trimming-cat-bath-service-long-haired-cat-grooming.png')" alt="cat hair trimming, cat bath service, long-haired cat grooming">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row margin-top-2 margin-bottom-2">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0 margin-top-1">
              <li class="float-start margin-right-2">
                <router-link class="text-black text-size-14 medium-family text-full-13" to="/">
                <i class="fa fa-home nav-color" aria-hidden="true"></i>
                Home /
                </router-link>
              </li>
              <li class="float-start">
                <router-link class="text-black text-size-14 medium-family text-full-13" to="/services/">
                Services
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { applyServicePageSchema } from '@/utils/seo';
  import { CAT_GROOMING_FAQS } from '@/utils/servicePageFaqs';

  export default {
    name: 'catGroomingBannerComponent',
    data() {
    return {
      isOpen: true,
      planDetailPrices: [], // Initialize as an empty array
    };
  },
      mounted() {
      this.fetchServiceCategories();
      this.applyStructuredData();
  },
      computed: {
        iconClass() {
          return this.isOpen ? "fa fa-check-circle-o text-green" : "fa fa-check-circle-o nav-color";
        },
      },
      methods: {
      applyStructuredData() {
        applyServicePageSchema({
          name: 'Mobile Cat Grooming in Dubai',
          description: this.$route.meta?.description || 'Mobile cat grooming services in Dubai.',
          path: this.$route.path,
          offers: (this.planDetailPrices || []).map((plan) => ({
            name: plan.name || plan.title || 'Cat Grooming',
            price: plan.price,
          })),
          faqs: CAT_GROOMING_FAQS,
        });
      },
        addToCart(service) {
        const cartData = localStorage.getItem('cart');
        let cart = cartData ? JSON.parse(cartData) : []; // Parse the cart or initialize as an empty array

        const serviceExists = cart.find((item) => item.id === service.id);

        if (serviceExists) {
          serviceExists.count++;
        } else {
          cart.push({ ...service, count: 1 });
        }
        localStorage.setItem('cart', JSON.stringify(cart));
        this.$router.push('/booking/');
      },
      async fetchServiceCategories() {
        try {
          const response = await this.$axios.post('/get-service-categories', {
            website_name: this.$websiteName,
            category_name: 'Cat Grooming',
          });
          if (response.data.status === "success") {
            this.planDetailPrices = response.data.planDetailPrices; // Assign the fetched data
            this.applyStructuredData();
          } else {
            console.error("Failed to fetch categories:", response.data);
          }
        } catch (error) {
          console.error('Error fetching categories:', error.response || error.message);
        }
      },
    previous() {
      const last = this.planDetailPrices.pop();
      this.planDetailPrices = [last].concat(this.planDetailPrices);
    },
    next() {
      const first = this.planDetailPrices.shift();
      this.planDetailPrices = this.planDetailPrices.concat(first);
    },
    toggleCollapse() {
      this.isOpen = !this.isOpen;
    },
  },
  }
</script>
<style scoped></style>